<template>
  <div class="hora">
    <div
      class="show container"
      style="font-family: IRANSansX-Regular">





      <div
        v-if="chartData['user']"
        class="row justify-content-md-center"
        style="direction: ltr"
      >

        <div

          class="col-12 col-md-11 col-lg-6 mr-auto mx-auto mb-3 p-0"
        >
          <div
            id="accordionPanelsStayOpenDashaDasha"
            :style="`width: ${box_width}px`"
            class="accordion mr-auto mx-auto"
            style="box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 2px; border-radius: 8px"
          >
            <div class="accordion-item">
              <h2
                id="panelsStayOpenDasha-headingOne"
                class="accordion-header">
                <button
                  class="accordion-button accordion-custom-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpenDasha-collapseOne"
                  aria-expanded="true"
                  aria-controls="panelsStayOpenDasha-collapseOne"
                >
                  دوره‌های سیاره‌ای
                </button>
              </h2>
              <div
                id="panelsStayOpenDasha-collapseOne"
                class="accordion-collapse collapse show"
                aria-labelledby="panelsStayOpenDasha-headingOne"
              >
                <div
                  class="accordion-body p-1"
                  style="background-color: #f9f9f9">
                  <DashaTable
                    v-if="chartData['dasha']"
                    :birthdate="chartData['user']['datetime']"
                    :date_type="chartData['user']['date_type']"
                    :data="chartData['dasha']"
                    :box_width="box_width"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>







import DashaTable from '../components/DashaTable.vue'
import HelperLib from '../components/helper'
import HoraLogo from '../components/HoraLogo.vue'

import ApiService from '../service/api'
import Loading from '../components/Loading.vue'

export default {
  name: 'Gc10ShareView',
  components: {




    DashaTable,
    HelperLib,
    HoraLogo,


    ApiService,
    Loading
  },
  data () {
    return {
      isLoading: false,
      chart2Varga: 'D9',
      chart3Varga: 'D30',
      chart2Text: 'D9 - Navamsa Chart',
      chart3Text: 'D30 - Trimshamsha',
      link_clicked: false,
      chartData: [],
      requestData: '',
      box_width: null,
      main_box_width: null,
      pages: {
        is_calculate: true,
        is_charts: false,
        is_notes: false
      }
    }
  },
  watch: {
    chartData: function (data) {
      this.chartData = data
    }
  },
  mounted: function () {

    this.adjustBoxesWidth()
  },
  created () {
    let id = document.getElementsByName('gc10_mmt_new_chart')[0]['value']
    console.log("id is",id)
    this.isLoading = true


    ApiService.getPreOrderGc10Chart(id).then((response) => {
      this.isLoading = false;
      this.chartData = response["data"];
    });


    //
    // ApiService.getSharedChart(id).then((response) => {
    //   this.isLoading = false
    //   console.log("response['data']",response['data'])
    //   this.chartData = response['data']
    // })





  },
  methods: {
    goToReport () {
      this.requestData = {
        id: this.chartData['link']
      }

      this.isLoading = true
      ApiService.createReportOrder(this.requestData).then((response) => {
        // console.log(response);
        this.isLoading = false
        window.location.replace(response['data']['checkout_url'])
      })
    },

    adjustBoxesWidth () {
      if (screen.width > 960) {
        // DESKTOP
        this.box_width = (this.$refs.chart_box.clientWidth * 92) / 100
        this.main_box_width = (this.$refs.chart_box.clientWidth * 97) / 100
      } else {
        this.box_width = (this.$refs.chart_box.clientWidth * 100) / 100
        this.main_box_width = this.box_width
      }
    },
    isMobile () {
      return HelperLib.isMobile()
    },
    showMobileViewChartHeader (width) {
      return `
      font-size: 12px;
      border-radius: 8px;
      width: ${width}px;
      line-height: 10px;
      color: #000;`
    },
    formatLocation (user) {
      let lonDir = user['longitude'] < 0 ? 'W' : 'E'
      let latDir = user['latitude'] < 0 ? 'S' : 'N'
      let out =
        user['latitude_dms']['deg'] +
        ' ' +
        latDir +
        ' ' +
        user['latitude_dms']['min'] +
        ' - '
      out +=
        user['longitude_dms']['deg'] + ' ' + lonDir + ' ' + user['longitude_dms']['min']
      return out
    },
    formatLagnaText (rashi) {
      return HelperLib.rashiToPersianText(rashi)
    },
    getSignLink (data) {
      var lagna = HelperLib.rashiToPersianText(data['lagna']['Lg']['rashi'])
      return `${lagna[1]}`
    },
    updateLoadedData (data) {
      this.chartData = data
      // this.$chartNoteListRef.getList();
    },
    updateShowAnalysisOption (data) {
      this.show_analysis = data
    }
  }
}
</script>

<style scoped>
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
.custom-accordion-header {
  background-color: #f2f2f2;
  color: #333;
  border: 1px solid #ccc;
}

.custom-accordion-header:hover {
  background-color: #e6e6e6;
}

.custom-accordion-header.active {
  background-color: #ddd;
}
.accordion-button-custom:not(.collapsed) {
  color: #000000;
  font-weight: bold;
  background-color: #fff;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

* {
  padding: 0px;
  margin: 0px;
}
.now-analysis {
  direction: rtl;
  text-align: right;
  background-color: rgba(255, 253, 231, 0.5);
  border-radius: 0.25rem;
  font-size: 16px;
  color: black;
  border: 1px solid rgb(242, 242, 242);
}
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
</style>
